// Text typed but not yet sent, kept per island. A page's teardown runs its parent's cleanup before its children's, so
// the island flushes its own editors itself before it destroys the outbox they write through.
export function createDrafts() {
	const registered = new Set<() => void>();
	return {
		register(flush: () => void) {
			registered.add(flush);
			return () => {
				registered.delete(flush);
			};
		},
		flush() {
			for (const flush of registered) flush();
		},
	};
}

export type Drafts = ReturnType<typeof createDrafts>;
